import type { AiModelStatus, AiUsageItem } from '@/api/types/ai-usages'

export type AiUsageFilter = {
  query: string
  changedOnly: boolean
}

export const KIND_LABELS: Record<AiUsageItem['kind'], string> = {
  text: 'テキスト',
  image: '画像付き',
  embedding: '埋め込み',
}

/** 検索語（空白区切りで全部含む）と「変更済みのみ」で絞る */
export const filterItems = (items: AiUsageItem[], { query, changedOnly }: AiUsageFilter): AiUsageItem[] => {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean)
  return items.filter((item) => {
    if (changedOnly && !item.customized) return false
    if (words.length === 0) return true
    const haystack = [
      item.label,
      item.description,
      item.source,
      ...item.models.map((model) => model.name),
      ...item.paid_models,
    ]
      .join(' ')
      .toLowerCase()
    return words.every((word) => haystack.includes(word))
  })
}

/** 無料枠をどれだけ使ったか（0〜1）。数えていないモデルは null */
export const quotaRatio = (model: AiModelStatus | undefined): number | null => {
  if (!model || model.daily_limit === null || model.used_today === null || model.daily_limit <= 0) return null
  return Math.min(model.used_today / model.daily_limit, 1)
}

/** 最初に試すモデルが今日どれだけ残っているか。残りが少ないほど目立たせる */
export const quotaTone = (ratio: number | null): 'none' | 'ok' | 'warn' | 'danger' => {
  if (ratio === null) return 'none'
  if (ratio >= 1) return 'danger'
  if (ratio >= 0.8) return 'warn'
  return 'ok'
}
